var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_1673)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41775 15.2837L6.90576 9.52148C7.90576 7.52148 8.55478 5.57442 9.46104 5.36048C10.3673 5.14655 11.2237 6.00297 12.9366 7.71583L16.3156 11.0948C18.0284 12.8077 18.8849 13.6641 18.6709 14.5704C18.457 15.4766 17.4058 15.5215 15.0099 16.6257L8.64293 19.5089C5.87751 20.4307 5.40567 21.8025 3.76493 20.1617C2.1242 18.5209 3.49595 18.0491 4.41775 15.2837Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1403_1673",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 17,
    width: 12,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21973 21.5801L15.268 17.1044L16.6749 20.2631L6.62662 24.7387L5.21973 21.5801Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1403_1673)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.2263,
    cy: 19.3033,
    r: 2.5,
    transform: "rotate(-36.6691 10.2263 19.3033)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L17.1753 7.40234",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.07617L14.0002 5.67353",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6626 9.26953L19 10.0799",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_1673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIcon);
export default __webpack_public_path__ + "static/media/newsIcon.58b8652b50de0d1317afffc3cc45ede6.svg";
export { ForwardRef as ReactComponent };